import { div, label, input, p, span, button } from '@srfnstack/fntags'
import { NumberSpinner } from '../../components/NumberSpinner.js'

export const CsvIngest = ({ csvBatchSize, csvUrlCount, ingestStatus, handleFileSelect, handleUpload }) =>
  div({ class: 'flex flex-col gap-3' },
    label({ class: 'label p-0' }, span({ class: 'label-text font-bold text-xs uppercase opacity-50' }, 'Upload CSV of Listing URLs')),
    div({ class: 'grid grid-cols-1 sm:grid-cols-4 gap-4' },
      label({
        class: 'sm:col-span-3 flex flex-col items-center justify-center border-2 border-dashed border-base-content/20 rounded-xl p-4 hover:border-primary/50 transition-colors cursor-pointer relative min-h-[120px]'
      },
      input({
        type: 'file',
        accept: '.csv',
        class: 'absolute inset-0 opacity-0 cursor-pointer',
        onchange: (e) => {
          const file = e.target.files[0]
          handleFileSelect(file)
        },
        disabled: ingestStatus.bindAttr(s => s && s.loading)
      }),
      ingestStatus.bindAs(s => s && s.loading
        ? span({ class: 'loading loading-spinner loading-md text-primary' })
        : span({ class: 'text-3xl mb-1' }, '📁')
      ),
      p({ class: 'text-sm font-medium' }, 'Drop CSV or click to browse'),
      csvUrlCount.bindAs(count => count > 0
        ? p({ class: 'text-sm text-primary font-black mt-2 bg-primary/10 px-3 py-1 rounded-full' }, `Found ${count} URLs`)
        : p({ class: 'text-[10px] opacity-60' }, 'One URL per row.')
      )
      ),
      div({ class: 'flex flex-col gap-3 justify-end' },
        div({ class: 'form-control' },
          label({ class: 'label p-0 mb-1' }, span({ class: 'label-text text-[10px] font-bold uppercase opacity-40' }, 'Images Per URL')),
          NumberSpinner({ state: csvBatchSize, min: 1, max: 100 })
        ),
        csvUrlCount.bindAs(count => count > 0
          ? button({
            class: 'btn btn-primary w-full',
            onclick: () => {
              const fileInput = document.querySelector('input[accept=".csv"]')
              if (fileInput && fileInput.files[0]) {
                handleUpload(fileInput.files[0])
              }
            },
            disabled: ingestStatus.bindAttr(s => s && s.loading)
          }, 'Upload All')
          : '')
      )
    )
  )
